(function () {
	let galleryTextSlide = () => {
		const isDesktop = window.matchMedia("(min-width: 990px)").matches;
		const $cards = $(".gallery-with-text__card");

		$cards.off(".galleryWithText");

		if (isDesktop) {
			$cards.on("mouseenter.galleryWithText", function () {
				let $this = $(this);
				$this.addClass("active");
				$this.siblings(".gallery-with-text__card").removeClass("active");
				setTimeout(function () {
					$this
						.children(".gallery-with-text__info")
						.children(".link--overlay")
						.addClass("active");
					$this
						.siblings(".gallery-with-text__card")
						.children(".gallery-with-text__info")
						.children(".link--overlay")
						.removeClass("active");
				}, 100);
			});
			return;
		}

		$cards
			.find(".link--overlay")
			.removeClass("active");

		$cards.on("click.galleryWithText", function (event) {
			if ($(event.target).closest("a, button").length) return;

			let $this = $(this);
			let isActive = $this.hasClass("active");

			$cards.removeClass("active");

			if (!isActive) {
				$this.addClass("active");
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		galleryTextSlide();
	});

	window.addEventListener("resize", galleryTextSlide);

	galleryTextSlide();
})();
